import { Divider, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, TextField } from "@material-ui/core";
import { EnumCuponCategoria, EnumTipoCodigoCupon } from "../../../../settings/enumConfig";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import MeditocModal from "../../../utils/MeditocModal";
import { useCupon } from "../../../../context/CuponContext";

export default function FormCupon() {
    const {
        modalOpenFormCupon,
        formCupon,
        handleOpenFormCupon,
        handleChangeFormCuponText,
        handleChangeFormCuponUInt,
        handleChangeFormCuponUDec,
        handleSubmitFormCupon,
    } = useCupon();

    const {
        rdCuponCodigo,
        txtCodigoCupon,
        txtLongitudCupon,
        txtTipoCupon,
        txtMontoDescuento,
        txtPorcentajeDescuento,
        txtTotalCupones,
        txtDiasActivos,
        txtDescripcion,
    } = formCupon;

    return (
        <MeditocModal
            title="Crear cupón"
            open={modalOpenFormCupon}
            setopen={handleOpenFormCupon}
            okfunc={handleSubmitFormCupon}
            okmessage="Guardar"
            size="small"
            form
        >
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <RadioGroup
                        row
                        name="rdCuponCodigo"
                        value={rdCuponCodigo.value}
                        onChange={handleChangeFormCuponText}
                    >
                        <FormControlLabel
                            control={<Radio />}
                            label="Código personalizado"
                            value={EnumTipoCodigoCupon.personalizado}
                        />
                        <FormControlLabel
                            control={<Radio />}
                            label="Código aleatorio"
                            value={EnumTipoCodigoCupon.aleatorio}
                        />
                    </RadioGroup>
                </Grid>
                <Grid item sm={6} xs={12} className="align-self-center">
                    {rdCuponCodigo.value === EnumTipoCodigoCupon.personalizado ? (
                        <TextField
                            name="txtCodigoCupon"
                            label={txtCodigoCupon.label}
                            required={txtCodigoCupon.required}
                            value={txtCodigoCupon.value}
                            error={txtCodigoCupon.error}
                            helperText={txtCodigoCupon.error && txtCodigoCupon.message}
                            onChange={handleChangeFormCuponText}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            autoFocus
                        />
                    ) : (
                        <TextField
                            name="txtLongitudCupon"
                            label={txtLongitudCupon.label}
                            required={txtLongitudCupon.required}
                            value={txtLongitudCupon.value}
                            error={txtLongitudCupon.error}
                            helperText={txtLongitudCupon.error && txtLongitudCupon.message}
                            onChange={handleChangeFormCuponUInt}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                        />
                    )}
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtTipoCupon"
                        label={txtTipoCupon.label}
                        required={txtTipoCupon.required}
                        value={txtTipoCupon.value}
                        error={txtTipoCupon.error}
                        helperText={txtTipoCupon.error && txtTipoCupon.message}
                        onChange={handleChangeFormCuponText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        select
                    >
                        <MenuItem value={EnumCuponCategoria.DescuentoMonto}>Descuento por monto</MenuItem>
                        <MenuItem value={EnumCuponCategoria.DescuentoPorcentaje}>Descuento por porcentaje</MenuItem>
                    </TextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                    {txtTipoCupon.value === EnumCuponCategoria.DescuentoMonto ? (
                        <TextField
                            name="txtMontoDescuento"
                            label={txtMontoDescuento.label}
                            required={txtMontoDescuento.required}
                            value={txtMontoDescuento.value}
                            error={txtMontoDescuento.error}
                            helperText={txtMontoDescuento.error && txtMontoDescuento.message}
                            onChange={handleChangeFormCuponUDec}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                        />
                    ) : (
                        <TextField
                            name="txtPorcentajeDescuento"
                            label={txtPorcentajeDescuento.label}
                            required={txtPorcentajeDescuento.required}
                            value={txtPorcentajeDescuento.value}
                            error={txtPorcentajeDescuento.error}
                            helperText={txtPorcentajeDescuento.error && txtPorcentajeDescuento.message}
                            onChange={handleChangeFormCuponUDec}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                        />
                    )}
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtTotalCupones"
                        label={txtTotalCupones.label}
                        required={txtTotalCupones.required}
                        value={txtTotalCupones.value}
                        error={txtTotalCupones.error}
                        helperText={txtTotalCupones.error && txtTotalCupones.message}
                        onChange={handleChangeFormCuponUInt}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtDiasActivos"
                        label={txtDiasActivos.label}
                        required={txtDiasActivos.required}
                        value={txtDiasActivos.value}
                        error={txtDiasActivos.error}
                        helperText={txtDiasActivos.error && txtDiasActivos.message}
                        onChange={handleChangeFormCuponUInt}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtDescripcion"
                        label={txtDescripcion.label}
                        required={txtDescripcion.required}
                        value={txtDescripcion.value}
                        onChange={handleChangeFormCuponText}
                        variant={inputVariant}
                        color={inputColor}
                        multiline
                        fullWidth
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
